import * as React from "react";
import { SVGProps } from "react";

const Dragonchain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-name="Layer 1"
    viewBox="0 0 1230 1318"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={985.22}
        x2={909.4}
        y1={359.88}
        y2={334.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#f3f5f7" />
        <stop offset={0.78} stopColor="#8099b9" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={1052.2}
        x2={964.92}
        y1={373.09}
        y2={369.07}
        gradientTransform="rotate(.28 829.99 509.543)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#f3f5f7" />
        <stop offset={0.37} stopColor="#e4e9ef" />
        <stop offset={0.48} stopColor="#c0ccdc" />
        <stop offset={0.59} stopColor="#a4b6cc" />
        <stop offset={0.7} stopColor="#90a6c2" />
        <stop offset={0.81} stopColor="#849cbb" />
        <stop offset={0.91} stopColor="#8099b9" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={919.35}
        x2={1102.79}
        y1={939.45}
        y2={1042.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.12} stopColor="#1797e5" />
        <stop offset={0.14} stopColor="#1693e1" />
        <stop offset={0.33} stopColor="#0a6fba" />
        <stop offset={0.48} stopColor="#0358a2" />
        <stop offset={0.57} stopColor="#005099" />
        <stop offset={0.71} stopColor="#0663ad" />
        <stop offset={0.99} stopColor="#1694e2" />
        <stop offset={1} stopColor="#1797e5" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={345.88}
        x2={994.06}
        y1={504.31}
        y2={1106.9}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.13} stopColor="#1797e5" />
        <stop offset={0.26} stopColor="#1693e1" />
        <stop offset={0.4} stopColor="#1287d4" />
        <stop offset={0.54} stopColor="#0b73be" />
        <stop offset={0.69} stopColor="#0257a0" />
        <stop offset={0.72} stopColor="#005099" />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="g"
        x1={659.63}
        x2={449.29}
        y1={967.62}
        y2={527.64}
      />
      <linearGradient
        id="b"
        x1={731.91}
        x2={539.77}
        y1={690.99}
        y2={649.04}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.17} stopColor="#f7ae2d" />
        <stop offset={0.86} stopColor="#b04211" />
      </linearGradient>
      <linearGradient
        xlinkHref="#b"
        id="h"
        x1={268.38}
        x2={411.71}
        y1={618.09}
        y2={630.62}
      />
      <linearGradient
        id="i"
        x1={316.85}
        x2={433.76}
        y1={566.95}
        y2={199.76}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26} stopColor="#1797e5" />
        <stop offset={0.4} stopColor="#1694e2" />
        <stop offset={0.51} stopColor="#138bd8" />
        <stop offset={0.61} stopColor="#0e7cc8" />
        <stop offset={0.7} stopColor="#0767b1" />
        <stop offset={0.77} stopColor="#005099" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={639.03}
        x2={550.29}
        y1={844.9}
        y2={818.23}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26} stopColor="#1797e5" />
        <stop offset={0.77} stopColor="#005099" />
      </linearGradient>
      <linearGradient
        xlinkHref="#c"
        id="j"
        x1={762.16}
        x2={640.61}
        y1={793.6}
        y2={821.91}
      />
      <linearGradient
        xlinkHref="#a"
        id="l"
        x1={183.78}
        x2={528.63}
        y1={148.16}
        y2={183.27}
      />
      <linearGradient
        xlinkHref="#a"
        id="m"
        x1={359.26}
        x2={586.19}
        y1={210.91}
        y2={210.91}
      />
      <linearGradient
        xlinkHref="#a"
        id="n"
        x1={485.97}
        x2={599.43}
        y1={227.93}
        y2={227.93}
      />
      <linearGradient
        xlinkHref="#a"
        id="o"
        x1={693.08}
        x2={640.29}
        y1={91.54}
        y2={9.35}
      />
      <linearGradient
        xlinkHref="#a"
        id="p"
        x1={656.67}
        x2={702.31}
        y1={116.77}
        y2={187.24}
        gradientTransform="matrix(-.87 -.49 -.49 .87 1577.97 399.07)"
      />
      <linearGradient
        xlinkHref="#a"
        id="q"
        x1={676.96}
        x2={657.47}
        y1={841.89}
        y2={748.07}
        gradientTransform="rotate(-44.67 744.727 359.379)"
      />
      <linearGradient
        xlinkHref="#a"
        id="r"
        x1={590.6}
        x2={549.94}
        y1={707.85}
        y2={631.82}
        gradientTransform="matrix(.71 -.7 .7 .71 -34.45 600.26)"
      />
      <linearGradient
        xlinkHref="#a"
        id="s"
        x1={336}
        x2={365.84}
        y1={449.49}
        y2={495.59}
        gradientTransform="rotate(-61.33 641.919 420.082)"
      />
      <linearGradient
        xlinkHref="#a"
        id="t"
        x1={308.94}
        x2={338.79}
        y1={397.77}
        y2={443.87}
        gradientTransform="rotate(-54.79 667.938 398.218)"
      />
      <linearGradient
        xlinkHref="#a"
        id="u"
        x1={371.08}
        x2={403.33}
        y1={263.18}
        y2={312.99}
        gradientTransform="matrix(-.33 .94 .94 .33 303.75 38.57)"
      />
      <linearGradient
        xlinkHref="#a"
        id="v"
        x1={345.94}
        x2={379.96}
        y1={317.14}
        y2={369.69}
        gradientTransform="matrix(-.33 .94 .94 .33 303.75 38.57)"
      />
      <linearGradient
        xlinkHref="#a"
        id="w"
        x1={322.59}
        x2={353.23}
        y1={383.34}
        y2={430.66}
        gradientTransform="matrix(-.33 .94 .94 .33 303.75 38.57)"
      />
      <linearGradient
        xlinkHref="#a"
        id="x"
        x1={259.86}
        x2={290.01}
        y1={355.79}
        y2={402.36}
        gradientTransform="rotate(-54.79 667.938 398.218)"
      />
      <linearGradient
        xlinkHref="#c"
        id="z"
        x1={814.07}
        x2={760.3}
        y1={748.27}
        y2={720.89}
      />
      <linearGradient
        xlinkHref="#c"
        id="A"
        x1={980.68}
        x2={912.16}
        y1={797.42}
        y2={762.54}
      />
      <linearGradient
        xlinkHref="#c"
        id="B"
        x1={537.41}
        x2={378.89}
        y1={818.77}
        y2={752.24}
      />
      <linearGradient
        xlinkHref="#c"
        id="C"
        x1={592.33}
        x2={417.75}
        y1={804.55}
        y2={739.91}
      />
      <linearGradient
        xlinkHref="#c"
        id="D"
        x1={625.25}
        x2={705.68}
        y1={431.46}
        y2={486.3}
      />
      <radialGradient
        xlinkHref="#c"
        id="k"
        cx={954.3}
        cy={969.82}
        r={404.26}
        gradientTransform="rotate(6.68 -1580.158 821.904) scale(1 .69)"
      />
      <radialGradient
        id="y"
        cx={271.28}
        cy={906.82}
        r={376.41}
        gradientTransform="matrix(1 0 0 .63 0 337.34)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.17} stopColor="#3fc0e5" />
        <stop offset={0.62} stopColor="#20a1e6" />
      </radialGradient>
    </defs>
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={18.911}
      d="M857.56 324.37s20.8-20.8 30.26-41.6c0 0-22.7-26.48 0-52.95 0 0 5.67-34-18.92-52.95 0 0 43.5-34 92.67 24.58 0 0 15.12-11.34 28.36 7.57 0 0 145.61 37.82 98.34 300.68z"
    />
    <path
      fill="url(#a)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={5.673}
      d="M937.93 295.06s17 5.67 26.47-3.78c0 0 33.41 63.66 9.14 126.38l-75.32-50.74s39.71-18.92 39.71-71.86z"
    />
    <path
      fill="url(#d)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={5.673}
      d="M978.09 281.63s17 .08 26.54-13.11c0 0 81 64.07 41.52 208.54l-55.51-55.43s32.47-66.03-12.55-140z"
    />
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={20.802}
      d="M131 441.39S14.15 485.11 31.17 547.52c0 0 3.6 20.54 40.57 15 0 0 81.46-115.69 59.26-121.13z"
    />
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={21.874}
      d="M87.38 865.24s-49.2 58.53-5.87 122.36A10.92 10.92 0 0 0 94 991.87c14.29-4.78 45.36-21 73.33-75.6zm77.47 157.64c-4 20.38-8.57 66.6 25.57 93.25a8.05 8.05 0 0 0 7.68 1.25c9.4-3.35 32.53-15.15 52.56-53.75a8.11 8.11 0 0 0-3.54-11l-70.72-35.36a8.09 8.09 0 0 0-11.55 5.61z"
    />
    <path
      fill="#7da4b7"
      d="M940.76 297.9s-1.41 47.51-30 60.63l15.45 1.62s18.36-22.54 18.36-60.36zm41.61-13.24s35.93 56.73 15.13 113.46l11.34 5.68s24.59-56.73-18.91-121z"
    />
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={21.874}
      d="M73.25 634.89s-94.09 92.12-51 144.39c0 0 12.25 18.07 45.56-3.16-.04 0 29.24-145.62 5.44-141.23z"
    />
    <path
      fill="#122a44"
      d="M296.51 1179.3s13.32 47.7 46.28 62.7c0 0 53.49 11.42 20.43-84.2z"
    />
    <path
      fill="#5dc5f9"
      d="M108.7 471.87s-68.08 28.37-60.52 79.43c0 0-13.23-1.89-7.56-24.58 0 0 3.78-32.15 64.3-62.41l15.13-7.56-9.46 15.12zM61.42 664.76s-66.18 71.86-28.36 109.68c0 0-1.89-71.86 39.71-98.33zm35.93 217.47s-26.47 47.28-1.89 92.67c0 0 11.35-3.79 13.24-7.57 0 0-1.89 9.46-17 15.13 0 0-39.71-39.71-1.89-104zm81.32 164.53s1.89 41.6 20.8 54.84c0 0 1.89 0 5.67-1.89 0 0-1.89 5.67-9.45 7.56 0 0-28.37-20.8-22.7-60.51z"
    />
    <path
      fill="url(#e)"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={18.911}
      d="M1097.72 833.07s92.66-172.09-13.23-317.7l-30.26-56.73s-3.78-9.46-13.24-7.57c0 0-26.47-45.38-58.62-52.95 0 0-24.59-37.82-70-39.71 0 0-11.35-53-71.86-43.49 0 0-13.24-52.95-68.08-30.26 0 0-9.45-28.37-43.49-18.91 0 0-1.89-51.06-132.38-11.35 0 0-391.45-54.84-469 181.54 0 0-3.53 8.84 6.47 11.14a.61.61 0 0 1 .34 1 90.72 90.72 0 0 0-21.94 54s-66.19 45.39-34 119.14c0 0-22.69 53 3.78 88.88 0 0-37.82 49.17 3.79 96.44 0 0-26.48 54.84 30.25 85.1 0 0-22.69 56.73 28.37 75.64 0 0-1.89 68.08 60.51 87 0 0 1.89 37.82 41.61 43.5 0 0-18.91 53 49.16 71.86 0 0 32.15 64.29 79.43 32.14 0 0 30.25 41.61 100.22 32.15 0 0 43.5 37.82 113.47 18.91 0 0 47.27 22.7 107.79-11.34 0 0 35.93 17 68.08-11.35 0 0 54.84 1.89 73.75-18.91 0 0 32.15 11.35 58.62-7.57 0 0 60.51-13.23 77.53 13.24 0 0 22.7 43.5-20.8 90.77 0 0 105.9 22.7 113.47-109.68 0 0 5.67-71.86-79.43-90.77z"
    />
    <ellipse cx={634.41} cy={772.55} fill="url(#f)" rx={442.51} ry={434.94} />
    <path
      fill="url(#g)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={13.237}
      d="m721.56 506.86 30.1 35s22.69-79.42-30.26 232.6l-30.26 88.88-377.26-35s-51.06-9.46-44.47-66.9l452.15-254.58"
    />
    <path
      fill="#c91111"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={18.911}
      d="m295.91 558.86 18.91-117.24 408.47 52.95-17.02 121.03-30.25 196.67-408.47-51.06 28.36-202.35z"
    />
    <path
      fill="#750606"
      d="m292.13 651.53-5.67 35.93 124.81 15.12 189.1 41.61v-20.8l92.08 18.09 4.37-38.9-404.69-51.05z"
    />
    <path
      fill="#3d0000"
      d="m655 513.44-275.88-39.67c-13.89 39.67-52.95 43.49-52.95 43.49L296 703.9c43.64 11.9 45.35 55.42 45.35 55.42l278 37.82c13.89-43.65 51-35.93 51-35.93l28.37-192.89C647.13 550.46 655 513.44 655 513.44zm9.64 240.2s-37.82-5.67-51.06 35.93l-264.72-35.93S347 712 305.37 700.69L330 558.86l5.68-34s37.82-5.67 51.05-43.49l261 37.82S640.09 557 689.25 574z"
    />
    <path
      fill="url(#b)"
      stroke="#4f1a00"
      strokeMiterlimit={10}
      strokeWidth={18.911}
      d="m587.14 604.25 124.81 20.8 64.29 92.66-56.73 32.15-17.02-37.82-122.92-22.69 7.57-85.1z"
    />
    <path
      fill="url(#h)"
      stroke="#4f1a00"
      strokeLinejoin="round"
      strokeWidth={13.237}
      d="m276.06 565.48 136.15 17L399 667.6l-126.7-15.13-3.79 18.91s-1.91-86.99 7.55-105.9z"
    />
    <path
      fill="#f7ae2d"
      stroke="#4f1a00"
      strokeMiterlimit={10}
      strokeWidth={18.911}
      d="m401.81 539.95-20.8 160.74 200.45 28.37 22.7-162.63-202.35-26.48z"
    />
    <path
      fill="#fff"
      d="m590.92 594.79-5.67 37.83-66.19 71.86-7.57-27.43 79.43-82.26zm-98.34-34.04-97.62 103.54-3.39 28.37 4.57.47 126.7-128.59-30.26-3.79zm39.72 5.68L401.81 695.02l15.13-9.45 121.03-119.14h-5.67z"
      opacity={0.63}
    />
    <path
      fill="#4f1a00"
      d="m483.13 634.51-20.8 41.6 48 4.66L502 636.4s15.13-1.89 17-18.91c0 0 3.78-24.59-20.8-28.37 0 0-20.8-1.89-26.48 18.91.06-.03-3.72 18.91 11.41 26.48z"
    />
    <path
      fill="#4f1a00"
      d="M502 585.34s24.58 3.78 24.58 28.36c0 0 1.89 20.81-15.13 28.37l3.83 52.93h7.56l-7.56-49.17s21.13-11.38 13.66-38.66a28.17 28.17 0 0 0-9.17-14.38 33.42 33.42 0 0 0-17.77-7.45z"
    />
    <path
      fill="#fff"
      d="M498.26 587.23S521 591 521 615.6c0 0 0 15.12-17 22.69l7.56 58.62h7.57l-9.46-56.73s12.33-4.83 14.55-20.87a28.11 28.11 0 0 0-24.51-31.94z"
    />
    <path
      fill="#3d0000"
      d="M657.11 768.77s-22.49-2.57-36.78 36.54l44.34-4.39zm9.45-272.31s-15.13 49.17 37.82 66.19l9.46-60.52zm-344.17-45.39-9.46 56.74s47.28-1.9 52.95-51.06zm-39.71 259.08L277 753.64l54.84 7.57s-7.56-41.61-49.16-51.06z"
    />
    <path
      fill="#5dc5f9"
      d="M615.5 275.2s39.71-32.14 100.23 0l-3.73 7.57s37.82-5.67 64.29 49.17c0 0 11.35-75.65 54.84 0 0 0 56.74-7.57 64.3 32.14 0 0-9.46 18.92 1.89 32.15 0 0-7.56-28.36 11.35-26.47 0 0 32.14 1.89 54.84 32.15l7.56 5.67s24.59 3.78 56.73 49.17a342.91 342.91 0 0 1 27.59 42.13 280.5 280.5 0 0 0 15.07 24.48c18.48 26.84 59.11 95.31 44.33 160.31 0 0-5.67 102.12-28.36 130.49 0 0 34-58.63 39.71-130.49 0 0 7.56-92.66-51.06-166.41l-32.15-60.51-11.34-5.68S1007 411.36 971 401.91v-3.79s-20.8-32.14-66.19-34l-1.89-7.56s-13.23-45.39-70-32.15c0 0-5.67-52.95-60.51-30.25 0 0-34-18.92-54.84-15.13 0 0 22.69-39.72-64.3-28.37 0 0-34.87 6-44.85 10.55z"
    />
    <path
      fill="url(#i)"
      d="M174.89 368.4S311 209 473.67 269.53c123.42 45.92 115.36 87 115.36 87s-83.74 13.12-122.61 66.19c0 0-75.81-82.79-173-12.74 0 .02-1.88-110.74-118.53-41.58z"
    />
    <path
      fill="#5dc5f9"
      d="M734.64 1220.73s-12.45 16-46.88-4.31c0 0-30.65 25.12-100.62 10 0 0-47.28 30.25-104-17 0 0-77.54 17-96.45-45.39 0 0-47.27 45.39-70-18.91 0 0-47.28 5.68-53-54.84 0 0 11.34-18.91 0-28.36 0 0-37.83 39.71-37.83-26.48 0 0-98.33-30.26-34-77.53 0 0-92.67 0-49.17-73.75 0 0-64.3-28.37-30.26-85.1 0 0-39.71-18.91-18.91-83.21l13.24-5.67s-35.93-41.6-5.68-81.32l1.9-7.56s-30.26-83.21 18.91-90.77l18.91-1.89s-17-45.39 17-75.65c0 0-15.13-73.75 126.7-149.39h-26.41s-98.33 43.5-122.92 139.94l7.57 9.45s-16 9.62-21.52 46.54c-.94 6.27-4 12.25-9.24 15.85C95.46 526.72 61.47 564 87.9 621.27c0 0-22.7 49.17 3.78 88.88 0 0-39.71 51.06 5.67 94.55 0 0-34 51.06 30.26 83.21 0 0-28.37 56.73 26.47 73.75 0 0-7.56 70 58.63 85.1 0 0-1.89 37.82 39.71 43.49l3.78 9.46s-20.8 45.38 45.39 62.4c0 0 30.25 66.19 75.64 28.37 0 0 26.47 45.38 98.33 34l9.46 5.67s43.49 32.15 104 13.24c0 0 47.27 22.69 107.79-11.35 0 0 32.15 17 60.51-7.56z"
    />
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={17.02}
      d="M486.91 952.2s-105.9-28.36-92.66-121c0 0-32.15-43.5-18.91-87 0 0 7.56-30.26 17-28.37 0 0 28.36-37.82 54.84-34 0 0-1.89 18.91 5.67 22.7 0 0 32.15-47.28 62.41-43.5 0 0-13.24 35.93 0 52.95 0 0 24.58-41.6 51.06-41.6 0 0-3.79 24.58 1.89 35.93 0 0 30.25-9.46 30.25 87 0 0 22.7 7.56 34 28.36l-3.78 105.9z"
    />
    <path
      fill="url(#c)"
      d="M542.07 726.35s64 144.54-19.23 189.92L611.72 903l3.78-88.88s-11.5-10.09-25.61-12.61c0 0 4.81-59.25-14.1-81.95z"
    />
    <path
      fill="#5dc5f9"
      d="M396.14 723.39s-26.48 51.05 13.24 105.9c0 0-13.24 81.31 83.2 107.79L468 939s-81.32-36-66.19-109.71c0 0-43.49-47.28-7.56-109.69zM854 1195.88l45.16-11.08s45.39-11.34 81.32 5.68c0 0 45.38 28.36 5.67 109.68H971s20.8-22.69 18.91-58.62c0 0 0-17-7.56-30.26 0 0-13.24-26.48-73.75-18.91l-15.13 3.78a54.16 54.16 0 0 1-49.17 7.56z"
    />
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={18.911}
      d="M746 719.6s-66.19-3.78-79.43 77.54l-39.71 7.56s-20.8 26.48-3.78 56.73c0 0-7.57 24.59 1.89 39.72 0 0-155.07-11.35-189.11 104 0 0-20.8 202.35 289.33 213.69 0 0 185.33 9.46 323.38-162.63l30.25-9.45 41.61 81.31s15.12-115.35 100.22-151.28c0 0-94.55-92.66-47.27-208l-94.56 56.73S1059.9 765 1042.88 765c0 0-1.89-13.24-13.24-17 0 0-11.34-22.69 1.9-60.51 0 0-37.83-18.91-88.88 39.71 0 0-18.91-7.57-24.59 13.24l-22.69-7.57s-7.56-26.47-26.48-24.58c0 0-7.56-7.57 13.24-71.86 0 0-54.84-7.57-90.77 51.06 0 0-20.8-7.57-26.47 13.23 0-.03-13.24 1.86-18.9 18.88z"
    />
    <path
      fill="url(#j)"
      d="m734.64 844.41-83.21-17 28.68-7.15a5 5 0 0 0 4.26-3.69c3.75-14.43 21.78-71.91 73-81.82l-5.67-5.67s-56.73-1.89-75.64 77.53l-43.5 9.46v32.13l90.77 22.69z"
    />
    <path
      fill="url(#k)"
      d="M604.16 1184.8s-73.76-111.57 11.34-104c0 0 18.91 0 90.77 20.8 0 0 22.7 3.78-3.78-26.48 0 0-37.82-32.15-66.19-41.6 0 0-24.58-30.26 32.15-17l32.15 5.67s30.26 7.57 37.82-26.47c0 0 5.67-34-41.6-30.26 0 0-5.68 0-13.24 5.67 0 0 26.48-37.82 71.86-13.23a83.64 83.64 0 0 1 18.91 11.34L797 948.42l20.81-3.78-17-54.84s-20.81 5.67-7.57-15.13l47.28-9.45s30.26-9.46 41.6-20.81c0 0 53-43.49 117.25-41.6 0 0 37.82-1.89 39.71-34 0 0 15.13 13.24 30.26 56.73 0 0 1.89 9.46 11.34 9.46l59.32-36.13 11.67 18.07s-21.77 61.51 38.74 152.28c0 0-54.84 60.52-75.64 122.92l-27.31-61.43-50.22 17.94s-115.39 211.8-433.08 136.15z"
    />
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={18.911}
      d="M649.54 330.05s-3.78-58.63-28.36-28.37c0 0-45.39-71.86 28.36-170.2 0 0 34-17 22.69-49.16 0 0 5.68-18.91 45.39-28.37 0 0-22.69-49.17-88.88-32.15 0 0-17-26.47-51.06-1.89 0 0-319.59-68.08-455.74 306.35 0 0 132.37-45.38 183.43-20.8 0 0 22.69 9.46 15.13 49.17 0 0 100.22-54.84 149.39 17 0 0 60.51-64.3 102.12-49.17 0 0 17 7.57 26.47 32.15"
    />
    <path
      fill="#1797e5"
      stroke="#122a44"
      strokeMiterlimit={10}
      strokeWidth={5.673}
      d="M670.34 432.16s-70-85.09-149.39-26.47c0 0-52-.95-74.7 46.33 0 0-3.78 5.67-3.78 9.45 0 0 30.26 7.57 30.26 45.39 0 0 7.56 0 26.47-49.17 0 0 30.26 5.68 34 47.28 0 0 7.57 1.89 24.59-11.35 0 0 5.67-32.15 15.12-35.93 0 0 24.59 0 30.26 41.61 0 0 3.78 7.56 37.82-22.7l51.06 5.68s9.5-15.13-21.71-50.12z"
    />
    <path
      fill="#5dc5f9"
      d="M734.64 833.07s-5.64 28.36-13.24 30.25l-85.1-20.8s-1.89-15.13 5.68-24.58l35.91-5.13a4.64 4.64 0 0 0 4-4.24c1.13-14.78 9.4-69.2 69.79-75.73l-4-3.78s-58.39-5.67-71.62 66.19c0 0-1.89 9.45-9.46 11.34l-34 5.68s-13.24 18.91-3.78 39.71l92.66 24.58s16.94 3.78 13.16-43.49zm75.64 20.8s-17 17-17 32.15c0 0 115.36-3.79 175.87 32.14l-185.34-24.58s-13.24-13.24 26.47-39.71zM677.91 988.13s6.6-23.13 29.09-21.51a14.88 14.88 0 0 1 9.85 4.72c4.42 4.75 10.24 14.34 10.24 31.92-.01 0-11.36-39.71-49.18-15.13zM573.9 954.1s6.61-23.1 29.1-21.52a14.86 14.86 0 0 1 9.85 4.72c4.42 4.75 10.24 14.34 10.24 31.92-.02 0-11.37-39.71-49.19-15.12z"
    />
    <path
      fill="none"
      stroke="#122a44"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={11.346}
      d="M680.74 989.08s30.26-26.48 37.83 13.24M580 957s25.23-27 35.81 8.62M810.28 852s-32.42 15.51-31.54 35.57a11.32 11.32 0 0 0 9.86 10.69L969.13 922"
    />
    <path
      fill="#f3f5f7"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={11.346}
      d="M806.18 900.55s-9.54 40.94 34.58 60.86a88.72 88.72 0 0 0 51 6.47c21.17-3.52 49.52-14.67 57.86-48.49z"
    />
    <path
      fill="none"
      stroke="#122a44"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={11.346}
      d="M738.42 833.07s3 24.66-3.23 39.07a15.33 15.33 0 0 1-18.11 8.43L621.66 855"
    />
    <path
      fill="#f3f5f7"
      stroke="#122a44"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={11.346}
      d="M710.06 880.34s15.12 22.7-3.79 43.5c0 0-37.82-18.91-88.88-18.91l7.61-47.28z"
    />
    <path
      fill="none"
      stroke="#122a44"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={9.455}
      d="M729 942.75s-20.3-20.75-46.1-27.42"
    />
    <path
      fill="#122a44"
      d="M1081.46 509.7s-58.46-21.7-50.87 65.24c0 0 6.62-80.37 60.41-50.2z"
    />
    <path
      fill="url(#l)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={5.673}
      d="M560.66 46.39s-4.73 25.53 4.73 40.61c0 0-128.59 43.5-226.93 213.69 0 0-22.69-68.07-162.63-13.23 0 .04 56.73-236.35 384.83-241.07z"
    />
    <path
      fill="url(#m)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={5.673}
      d="m569.17 100.28 17 17S486 223.2 463.27 321.54c0 0-39.71-28.37-104-5.68-.01 0 66.18-149.39 209.9-215.58z"
    />
    <path
      fill="url(#n)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={5.673}
      d="M599.43 132.43s-64.3 83.21 0 183.43c0 0-51.06-45.38-113.46 7.57.03 0 37.82-136.16 113.46-191z"
    />
    <path
      fill="#122a44"
      d="M897 912.48s-21.43 36.62 17.79 48.57c0 0 29.06-18.43 32.25-42zm-222.62-41.65s-21.06 26.53-4 37.88l35.93 9.45s15.65-25.7-5.41-40.27z"
    />
    <circle cx={895.38} cy={944.64} r={9.46} fill="#fff" />
    <circle cx={666.56} cy={889.8} r={9.46} fill="#fff" />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.782}
      d="M906.73 623.16s1.89-22.69 18.91-24.58c0 0 22.69 0 24.58 20.8 0 0-5.67-34 18.91-39.71"
    />
    <path
      fill="#122a44"
      d="M1135.24 677.53s-26.17-24.11-60.21 49.64c0 0 44.48-46.31 60.06-42.07zm-4.54-54.09s-33-47.56-53.78 18.63c0 0 10.23-17.9 21.23-25.32a11.61 11.61 0 0 1 13.91.69c6.34 5.34 15.89 18.26 23.07 49.37zM1039 447.89s-43.41 7-28.29 50.46c0 0-2.84-41.74 44-38.84zm-51.66-48.28s-28.83 2.41-9.55 47.46a7.84 7.84 0 0 1-2.86 9.6 7.84 7.84 0 0 1-10.16-1.25c-4.12-4.54-12-13.68-19.44-18.78a6.15 6.15 0 0 0-9.48 3.58c-1.7 7.24-1.77 22.82 4.91 56.24 0 0-24.8-37.21-14-63.9 3.89-9.64 15.62-13.81 24.44-8.3a34.85 34.85 0 0 1 8.53 7.9s-12.8-49.98 27.61-32.55zM924 359.72s-45 3.28-26.77 35.78a12.22 12.22 0 0 0 2.42 3l7.44 6.8a7.67 7.67 0 0 1 .64 8.81 7.65 7.65 0 0 1-8 3.59c-9.5-1.84-30.81-10.11-43.53 9.94a11.87 11.87 0 0 0-1.36 10.07 25.31 25.31 0 0 0 10.3 13.37s-30.25-15.13-7.56-37.82c0 0 7.56-9.45 28.36-9.45 0 0-28.13-49.45 25.65-48.37zM693 296s43.38-41.58 75.36 9.58a32.67 32.67 0 0 1 3.27 7l4.57 13.72s-22.69-1.89-34 18.91l-7.56-7.56s3.78 22.69 35.93 54.84c0 0 1.89-15.13-18.91-37.82 0 0 22.69-34 47.28-11.35 0 0 11.34 5.68 32.14 39.72 0 0-5.67-32.15-41.6-54.85 0 0-11.35-49.16-47.28-58.62 0-.04-34.04-7.57-49.2 26.43zM615.39 11.4s-15 12.29-1.78 53.9c0 0-17-26.48-11.34-54.84zm7.68 67.13s25.25 26.53 51.39 14.21L673 105.32s-40.48-.32-49.93-26.79z"
    />
    <path
      fill="#122a44"
      d="M572 48.28s7.56-20.8 32.15-34l-28.37 1.89s-5.66 7.52-3.78 32.11zm39.72 54.84s13.24 26.47 54.84-3.78l-3.78 26.47s-41.6 7.57-51.06-22.69z"
    />
    <path
      fill="url(#o)"
      d="M710.06 52.06S672.23 63.41 666.56 88c0 0-52.95-17-41.6-62.41.04-.01 68.04-17.02 85.1 26.47z"
    />
    <path
      fill="url(#p)"
      d="M876.47 180.65s24 26.81 17 51.06c0 0 53 11.35 64.29-26.47.02 0-45.31-54.37-81.29-24.59z"
    />
    <path
      fill="url(#q)"
      d="M1023.48 692.44s-14.65 37.84-1.4 59.31c0 0-53 15.13-77.53-15.13 0 0 41.6-58.62 78.93-44.18z"
    />
    <path
      fill="url(#r)"
      d="M872.69 645.85s-18.91 35.93-11.35 70c0 0-47.44 13.88-68.43-19.57 0-.03 38.17-67.45 79.78-50.43z"
    />
    <path
      fill="url(#s)"
      d="M564.27 674.52s-7.77 22.43 4 43.19c0 0-25 17.71-45.39 0-.04 0 11.31-34.04 41.39-43.19z"
    />
    <path
      fill="url(#t)"
      d="M506.83 668.36s-10.27 21.39-1 43.35c0 0-26.85 14.75-45.09-5.17 0 0 15.16-32.54 46.09-38.18z"
    />
    <path
      fill="url(#u)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={8.51}
      d="M438.69 529.55s10.76-19.41 34-24.58c0 0-3.38-35.16-30.18-38.48.04 0-17.14 34.57-3.82 63.06z"
    />
    <path
      fill="url(#v)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={8.51}
      d="M498.66 522.4s9.41-14.15 32.69-19.32c0 0-4.73-38.77-29.31-42.55-.04 0-18.91 34.04-3.38 61.87z"
    />
    <path
      fill="url(#w)"
      stroke="#122a44"
      strokeLinejoin="round"
      strokeWidth={8.51}
      d="M566.74 522.4s11.47-20.77 34.75-25.95c0 0-2.68-32.61-29.48-35.92-.01 0-18.59 33.38-5.27 61.87z"
    />
    <path
      fill="url(#x)"
      d="M445.31 687.46s-13.05 17.41-3.77 39.38c0 0-25 11-43.2-9 0 .05 16.71-32.28 46.97-30.38z"
    />
    <path
      fill="#122a44"
      d="M627.55 20.23S617.39 61.52 670.34 88l-3.78 5.67s-56.73-17-45.38-71.86zm345.36 179.33S978.59 226 946.44 245c0 0 32.15-9.46 34-39.71z"
    />
    <path
      fill="url(#y)"
      d="M411.27 1173.46s-274.21-162.63-206.13-533.28L131.39 712s-13.24 314 279.88 461.46z"
    />
    <path
      fill="#5dc5f9"
      d="M216.49 572.1s17 24.58 39.71 0c0 0-19.85 32.15-39.71 0z"
    />
    <path
      fill="#122a44"
      d="M982.2 211.75s8.51 16.89 2.32 40.76c0 0 9.44-9.84 11.91-34.37zM885.92 245s15.13 22.69 49.17 5.67c0 0-34 7.57-47.27-11.35z"
    />
    <path
      fill="#122a44"
      d="M885.92 248.73s5.68 34 41.61 30.26c0 0-19.63 11.72-41 2.08zm71.86-47.28s-11.34 43.5-68.07 26.48l-1.89 9.45s64.29 18.91 83.2-37.82zM547.42 1203.71s56.16-1.53 57.4 54.08l-22.1-3.34s13.87-37.45-35.3-50.74zM458.54 1164s42.18 20.63 24.87 75.56l-13.48-4.93s15.07-55.5-11.39-70.63zm-185.32-121s24.58 49.17-30.26 62.41l-11.34-17s43.49 11.3 41.6-45.41zm-92.66-92.69s-1.89 24.59-37.82 18.91l1.77-10.63a.52.52 0 0 1 .74-.4c3.56 1.69 21.75 9.1 35.31-7.88zm-41.56-295s-15.17 68.08-53 51.06l-7.57 15.12S139 746.08 139 655.31zm-62.45-51.06s26.45 54.84 51.06-32.15c0 0 3.78 77.53-49.17 60.52zm45.39-107.79s-3.79 41.6 45.38 24.58c0 0-43.49 41-63.35-6.93zm15.12-64.3s13.24 39.71 71.86-18.91c0 0-56.73 83.21-3.78 87 0 0-47.27 7.57-26.47-47.28 0 0-21.95 21.13-46.9-1.73zm47.28 162.63s20.8 5.68 30.26-18.91c0 0 11.34 20.8 32.15 9.46 0 0 7.56-3.78 13.23-20.8 0 0-13.23 30.25-34 17 0 0-11.34-5.68-11.34-22.7-.04.02-5.72 35.95-30.3 35.95z"
    />
    <path
      fill="#5dc5f9"
      d="M592.81 46.39s13.24 34 26.47 49.16c0 0-34.03-11.34-26.47-49.16zM154.08 297.9s70-172.09 204.24-221.26c0 0 104-43.49 208-39.71 0 0-175.87-20.8-281.77 70 .02-.03-92.64 69.94-130.47 190.97zm465.2-162.63s-58.62 64.29-11.34 172.08c0 0-68.08-88.88 11.34-172.08zM916.42 263.1s40 3.34 63.66-23.92c0 0-15.44 43.67-63.66 23.92zm98.1-10.59s62.4 58.62 53 202.35c-.05 0 32.09-139.94-53-202.35z"
    />
    <path
      fill="url(#z)"
      d="M763 746.08s3.78 13.24 20.8 22.69c0 0-26.48-47.28 30.25-49.17L780 695s-24.56 22.71-17 51.08z"
    />
    <path
      fill="#7da4b7"
      d="m193.8 279-15.13 5.67S207 180.65 311 116.36c0 0 92.66-70 247.73-68.08a19.55 19.55 0 0 0-1.89 7.56S273.22 55.84 193.8 279zM364 311.13s68.08-145.61 204.24-208l3.76 3.77s-104 34-200.45 202.34z"
    />
    <path
      fill="#5dc5f9"
      d="M780 695a19.18 19.18 0 0 0 3.79 15.13s-22.7 17-17 43.49c0 .02-20.79-43.47 13.21-58.62z"
    />
    <path
      fill="#7da4b7"
      d="M589 144.72s-62.41 51.06-98.34 172.09l7.57-5.68s17.05-75.64 90.77-166.41z"
    />
    <path
      fill="#122a44"
      d="M789.48 691.24s22.69 34 77.53 20.8l7.57 3.78s-54.84 30.26-96.45-22.69z"
    />
    <path
      fill="#122a44"
      d="M774.35 696.91s13.24 34 43.5 37.82c0 0-28.37 1.89-51.06-32.15z"
    />
    <path
      fill="url(#A)"
      d="M929.77 736.17s-26.83 42.06-15.48 57.19c0 0 1.89 9.45 17 13.23 0 0-7.56-26.47 9.45-41.6a210.84 210.84 0 0 0 28.37 15.13l9.48-15.12s-22-.92-48.82-28.82"
    />
    <path
      fill="#122a44"
      d="M833 738.51s41.61 1.9 41.61-26.47l7.56 9.45s-3.81 22.7-49.17 17.02zm-66.21-34.03s-13.24 18.91 0 49.16c0 0-24.59-22.69-22.7-35.93z"
    />
    <path
      fill="#122a44"
      d="M844.32 768.77s41.6 15.13 49.17-37.82l-11.35-15.13s0 49.18-37.82 52.95zm81.32-24.58s-18.91 26.47-9.46 52.95c0 0-20.8-11.35-1.89-58.63zm37.82 71.86s71.58 39.58 83.06-50.18l-9.31-12.23s0 83.21-73.75 62.41z"
    />
    <path
      fill="url(#B)"
      d="M413.16 729.06s-17 73.75 70 119.14c0 0-30.26-64-37.82-120.29z"
    />
    <path
      fill="url(#C)"
      d="M476.51 713.93s-14.18 87 59.57 132.37l-3.78-26.47S507.71 753.64 511.49 712z"
    />
    <path
      fill="#122a44"
      d="M984.26 782s46.78 8.07 52.7-23.39l-3.53-6.87s-3.79 28.38-49.17 30.26zm-58.62-47.27s-3.79 17 28.36 37.82c0 0-20.8-1.89-34-30.25z"
    />
    <path
      fill="#122a44"
      d="M942.66 731s24.58 37.82 83.2 15.13l7.57 13.24s-68.08 32.14-105.9-26.48z"
    />
    <path
      fill="#5dc5f9"
      d="M935.09 793.36s26.48 13.23 79.43 5.67c0-.03-51.06 34.04-79.43-5.67zm-145.61-47.28s24.58 11.34 77.53 3.78c-.01 0-41.6 35.93-77.53-3.78z"
    />
    <path
      fill="#122a44"
      d="M390.47 723.39s18.91 18.91 56.73 9.45l5.67-28.36-13-5.46s-6 13-4.06 26.26c0 0-22.69 5.67-39.71-9.46z"
    />
    <path
      fill="#122a44"
      d="M391.41 724.33s1.89 13.24 22.69 15.13c0 0-18 2.84-27.42-12.29zm33.1 16.08s18.91 1.89 22.69-11.35l1.89 11.35a31.19 31.19 0 0 1-24.58 0z"
    />
    <path
      fill="#122a44"
      d="M458.54 708.26s-11.34 47.27 1.9 77.53c0 0-24.59-35.93-11.35-79.42zm3.79-7.57s18.91 17 49.16 5.68V712s-32.14 17-51.05-5.67z"
    />
    <path
      fill="#122a44"
      d="M456.65 706.37a39.63 39.63 0 0 0 24.59 17s-18.91 0-28.37-11.35zm37.82 17.02s17-3.79 17-13.24l1.9 9.45s-5.66 5.68-18.9 3.79z"
    />
    <path
      fill="#122a44"
      d="M511.49 717.71s-18.91 34 15.13 85.1c0 0-20.8-56.73-7.56-85.1z"
    />
    <path
      fill="#122a44"
      d="M521 713.93s26.47 17 49.17 0l7.56 5.67s-26.47 22.7-60.51 1.89z"
    />
    <path
      fill="#122a44"
      d="M515.28 721.49s5.67 11.35 30.25 15.13c0 0-18.91 1.89-32.14-5.67zM555 734.73s15.13 0 22.69-17l5.67 9.46a40.16 40.16 0 0 1-28.36 7.54zm7.55 15.13s18.91-1.89 24.59-17l1.86 9.44s-7.54 9.45-26.45 7.56zm11.35-295s0-35.93 56.73-34c0 0-71.86-15.13-64.29 43.49zM604.16 470s7.56 11.35 3.78 28.37l8.36-2.54s-.8-20.17-12.14-25.83zM503.2 458.92s10.19-40 76.37-45.67c0 0-79.42-1.89-83.2 45.39z"
    />
    <path
      fill="url(#D)"
      d="M645.76 413.25s47.28 35.93 45.38 66.19l-51-5.67s26.42-17.02 5.62-60.52z"
    />
    <path
      fill="#122a44"
      d="M502 1063.78s39.71-60.52 172.09 13.23c.04-.01-111.54-100.22-172.09-13.23z"
    />
    <path
      fill="#5dc5f9"
      d="M502 1075.12s35.93-56.73 174 11.35c0 0-119.12-92.66-174-11.35z"
    />
    <path
      fill="#5dc5f9"
      d="M723.29 950.31S568 867.89 476.41 973a76.74 76.74 0 0 0-14.5 75.62c16.59 47.79 63.4 122.45 195.2 143.79 0 0 221.25 47.28 374.43-143.72l28.36-26.48s-153.17 266.6-476.55 164.49c0 0-146.35-43.16-140-178.06a18.36 18.36 0 0 1 .53-3.53c3.33-13.16 27.56-89.33 143.28-94.51 0 0 102.11-9.45 138 35.93l3.84 7.57a23.17 23.17 0 0 0-5.71-3.79z"
    />
    <path
      fill="#5dc5f9"
      d="M1151.64 816.94s-13.41 72.77 47.2 148.47l-6.56 17.05s-49.17 26.48-75.65 117.25l-30.25-58.63s-3.79-5.67-15.13-1.89l-20.8 7.57 1.89-7.57 22.69-9.45s13.24-3.78 18.91 7.56l20.8 43.5s13.24-64.3 71.86-105.9c0 0-52.95-83.21-43.49-145.61l8.53-12.35"
    />
    <path
      fill="#122a44"
      d="M1018.3 1077s47.27-56.73 51.06-73.75c0 0-13.24 47.28-34 73.75z"
    />
    <path
      fill="#5dc5f9"
      d="M1069.36 884.13s45.38-26.48 70-85.1l15.12-3.78s3.76 73.75-85.12 88.88z"
    />
    <path
      fill="#122a44"
      d="M1146.89 782s-15.13 68.08-77.53 102.12c0 0 64.29-28.37 92.66-92.67zm-56.73 155.08s49.3 38.71 119.2 26.92v18.22s-70.03 2.13-119.2-45.14z"
    />
    <path
      fill="#fff"
      d="m305.37 649.63 62.4-66.18h-3.78l-62.4 66.18h3.78zm-15.13-1.89 68.08-66.18-17.02-1.9-66.19 66.19 15.13 1.89z"
      opacity={0.63}
    />
    <path
      fill="#4f1a00"
      d="m329.95 587.23 56.73 11.35v-5.68l-56.73-5.67zm-11.34 52.95 62.4 5.67-1.89 5.68-60.51-11.35zm175.87-68.08 85.09 13.24-13.23 107.79 7.56-3.78 13.24-107.79-92.66-9.46zm109.68 47.28L659 630.72l-56.74-3.78 1.9-7.56zm-9.46 54.84 54.84 11.35-54.84-5.68v-5.67z"
    />
    <path
      fill="#fff"
      d="m617.39 621.27 88.88 13.24 39.72 58.62-35.93-45.39-5.68 52.95h-3.78l3.78-60.51-86.99-18.91z"
    />
    <path
      fill="#4f1a00"
      d="M689.25 691.24s24.59 0 30.26 26.47c0 0 0-28.36-30.26-26.47z"
    />
    <path
      fill="#fff"
      d="M422.61 570.21s-7.56 81.32-15.12 111.57c0 0 5.67-85.1 15.12-111.57z"
    />
    <path
      fill="#fff"
      d="m477.46 564.54-62.41-5.68s-9.46 90.77-17 128.6c0 0 5.67-100.23 13.24-136.16zM277 643.96l11.35-64.3 92.66 11.35-98.33-17.02-5.68 69.97z"
    />
    <path
      fill="#fff"
      d="m577.68 553.19-17.02 17.02-15.13-1.89 17.02-17.02 15.13 1.89z"
      opacity={0.63}
    />
  </svg>
);

export default Dragonchain;
